import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed } from 'vue';

interface Props {
  size?: 'xs'|'sm'|'md'|'lg';
  color?: 'primary'|'secondary'|'success'|'danger'|'warning';
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Spinner',
  props: {
    size: { default: 'md' },
    color: { default: 'primary' }
  },
  setup(__props: any) {

const props = __props as { size: 'xs'|'sm'|'md'|'lg', color: 'primary'|'secondary'|'success'|'danger'|'warning' }


const styles = computed(() => {
  const sizeFunc = (size: number) => ({
    width: `${size}rem`,
    height: `${size}rem`,
  });

  switch (props.size){
    case 'xs': return sizeFunc(0.75);
    case 'sm': return sizeFunc(1);
    case 'md': return sizeFunc(1.25);
    case 'lg': return sizeFunc(1.5);
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", {
      class: _normalizeClass(["spinner", [`color-${__props.color}`]]),
      style: _normalizeStyle(_unref(styles))
    }, null, 6)
  ]))
}
}

})